module.exports = __webpack_public_path__ + "assets/img/pc.d720b06f.jpg";